import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function K({ langKey }: any) {
    const { useLang, Link } = useGlobal();
    const { t } = useLang(langKey || 'poweroceancollection');

    const cards: any = [
        {
            img: require('@publicLocal/power-ocean/collection/pc/de/11_1.jpg'),
            title: t('secK_card1_title'),
            link: 'https://blog.ecoflow.com/de/pv-anlage-steuerfrei/',
        },
        {
            img: require('@publicLocal/power-ocean/collection/pc/de/11_2.jpg'),
            title: t('secK_card2_title'),
            link: 'https://blog.ecoflow.com/de/was-ist-ein-wechselrichter/',
        },
        {
            img: require('@publicLocal/power-ocean/collection/pc/de/11_3.jpg'),
            title: t('secK_card3_title'),
            link: 'https://blog.ecoflow.com/de/photovoltaik-speicher-10-kwh/',
        },
    ];

    return (
        <div className={`power-ocean-collection-K ${css['power-ocean-collection-K']}`}>
            <div className="text-box">
                <p className="title">{t('secK_title')}</p>
            </div>
            <div className="card-box">
                {cards?.map((card: any, k: number) => (
                    <div key={k} className={`card card${k + 1}`}>
                        <div className="card-img">
                            <NextImage src={card?.img} alt={card?.title} aria-label={card?.title} />
                        </div>
                        <div className="card-text">
                            <p className="card-title">{card?.title}</p>
                            <Link className="card-link" href={card?.link}>
                                <span className="link-text">{t('secK_card_more')}</span>
                                <svg className="link-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M6 12L10 8L6 4" stroke="#2673FF" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
